import { createRoutine } from 'redux-saga-routines';

export const fetchOnHoldReservations = createRoutine(
  'FETCH_ON_HOLD_RESERVATIONS'
);
